import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { SensorFilter, UpdateStatusShape } from "@shared/interfaces";

import { CreateSensorDto } from "../interfaces";

export default {
  getSensors: (payload: SensorFilter) => {
    const { hospital, ...restPayload } = payload;
    const hospital_id = hospital ? Number(hospital.value) : undefined;

    return request(METHODS.GET, API.SENSOR.GET_SENSORS)({ params: { ...restPayload, hospital_id } });
  },
  createSensor: (payload: CreateSensorDto) => request(METHODS.POST, API.SENSOR.CREATE_SENSOR)(payload),
  updateSensor: (payload: CreateSensorDto & { id: number }) => {
    const { id, ...rest } = payload;
    return request(METHODS.PUT, API.SENSOR.UPDATE_SENSOR(String(id)))(rest);
  },
  updateSensorStatus: (payload: UpdateStatusShape) => {
    const { id, status } = payload;
    return request(METHODS.PUT, API.SENSOR.UPDATE_SENSOR_STATUS(String(id)))({ status });
  },
};
